let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("bfhXH")]).then(() => parcelRequire('l5Yc7'));